import { render, staticRenderFns } from "./PrivacyAxisTrue.vue?vue&type=template&id=4b3dab84&scoped=true"
import script from "./PrivacyAxisTrue.vue?vue&type=script&lang=js"
export * from "./PrivacyAxisTrue.vue?vue&type=script&lang=js"
import style0 from "./PrivacyAxisTrue.vue?vue&type=style&index=0&id=4b3dab84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3dab84",
  null
  
)

export default component.exports